<div id="nav-icon" [class]="{'open': open}">
  <span></span>
  <span></span>
  <span></span>
  <span></span>
</div>